export default function dataGenerator(lng) {

	const cards_1 = [
		{
			products_cod: ["AUN20000FRLL0"],
			products_type: ["Ø 2 mm"],
		},
		{
			products_cod: ["AUN22000DR000", "AUN28000DR000", "AUN32000DR000", "AUN34000DR000", "AUN37000DR000", "AUN41000DR000", "AUN46000DR000", "AUN56000DR000"],
			products_type: ["Ø 2.2 mm", "Ø 2.8 mm", "Ø 3.2 mm", "Ø 3.4 mm", "Ø 3.7 mm", "Ø 4.1 mm", "Ø 4.6 mm", "Ø 5.6 mm"]
		},
		{
			products_cod: [
				["AIF33080FRFI0", "AIF33100FRFI0", "AIF33115FRFI0", "AIF33130FRFI0", "AIF33150FRFI0", "AIF37080FRFI0", "AIF37100FRFI0", "AIF37115FRFI0", "AIF37130FRFI0", "AIF37150FRFI0"],
				["AIF42080FRFI0", "AIF42100FRFI0", "AIF42115FRFI0", "AIF42130FRFI0", "AIF42150FRFI0", "AIF50080FRFI0", "AIF50100FRFI0", "AIF50115FRFI0", "AIF50130FRFI0", "AIF50150FRFI0"]
			],
			products_type: [
				["Ø 3.3 mm", "Ø 3.3 mm", "Ø 3.3 mm", "Ø 3.3 mm", "Ø 3.3 mm", " Ø 3.75 mm", " Ø 3.75 mm", " Ø 3.75 mm", " Ø 3.75 mm", " Ø 3.75 mm"],
				["Ø 4.2 mm", "Ø 4.2 mm", "Ø 4.2 mm", "Ø 4.2 mm", "Ø 4.2 mm", "Ø 5 mm", "Ø 5 mm", "Ø 5 mm", "Ø 5 mm", "Ø 5 mm"],
			],
			products_detail: [
				["h. 8 mm", "h. 10 mm", "h. 11.5mm", "h. 13 mm", "h. 15 mm", "h. 8 mm", "h. 10 mm", "h. 11.5mm", "h. 13 mm", "h. 15 mm"],
				["h. 8 mm", "h. 10 mm", "h. 11.5mm", "h. 13 mm", "h. 15 mm", "h. 8 mm", "h. 10 mm", "h. 11.5mm", "h. 13 mm", "h. 15 mm"]
			]
		},
		{
			products_cod: [
				["AUN35LARFO000"],
				["AUN00000FOGU0"]
			],
			products_type: lng === "es" ?
				[
					["Larga"],
					["Guía"]
				] :
				[
					["Wide"],
					["Guide"]
				],
			products_detail: [
				["", ""],
				["", ""]
			]
		},
		{
			products_cod: ["AUN3505000ST0", "AUN3507000ST0", "AUN3508000ST0", "AUN3510000ST0", "AUN3511500ST0", "AUN3513000ST0", "AUN3515000ST0"],
			products_type: ["Ø3.5 mm. - L.5 mm", "Ø3.5 mm. - L.7 mm.", "Ø3.5 mm. - L.8 mm.", "Ø3.5 mm. - L.10 mm.", "Ø3.5 mm. - L.11.5 mm.", "Ø3.5 mm. - L.13 mm.", "Ø3.5 mm. - L.15 mm"],
		},
		{
			products_cod: ["AUN5505000ST0", "AUN5507000ST0", "AUN5508000ST0", "AUN5510000ST0", "AUN5511500ST0", "AUN5513000ST0", "AUN5515000ST0"],
			products_type: ["Ø5.5 mm. - L.5 mm.", "Ø5.5 mm. - L.7 mm.", "Ø5.5 mm. - L.8 mm.", "Ø5.5 mm. - L.10 mm.", "Ø5.5 mm. - L.11.5 mm.", "Ø5.5 mm. - L.13 mm.", "Ø5.5 mm. - L.15 mm."],
		}
	]
	const cards_2 = [
		{
			products_cod: ["AUN41000MU000", "AUN50000MU000"],
			products_type: ["Ø 4.1 mm", "Ø 5 mm"]
		}
	]
	const cards_3 = [
		{
			products_cod: ["AST00300APCRC"],
			products_type: [""],
			products_detail: ["L. 19 mm"]
		},
		{
			products_cod: ["AST00000APCRC"],
			products_type: [""],
			products_detail: ["L. 13 mm"]
		},
		{
			products_cod: [
				["AST00000CMCAC"],
			],
			products_type: [
				[""],
			],
			products_detail: [
				["L. 14 mm"],
			]
		},
		{
			products_cod: ["AST12000APCAB"],
			products_type: ["Ø 1.20"],
			products_detail: ["L. 14 mm"]
		},
		{
			products_cod: ["AST12SHOAPCAB"],
			products_type: ["Ø 1.20"],
			products_detail: ["L. 9 mm"]
		},
		{
			products_cod: ["AST12030APCRB"],
			products_type: ["Ø 1.20"],
			products_detail: ["L. 25 mm"]
		},
		{
			products_cod: ["AST12000APCRB"],
			products_type: ["Ø 1.20"],
			products_detail: ["L. 14 mm"]
		},
		{
			products_cod: ["AST12SHOAPCRB"],
			products_type: ["Ø 1.20"],
			products_detail: ["L. 8 mm"]
		},
		{
			products_cod: ["AST00000APCRE"],
			products_type: [""],
			products_detail: ["L. 14 mm"]
		},
		{
			products_cod: ["AST00SHOAPCRE"],
			products_type: [""],
			products_detail: ["L. 8 mm"]
		}
	]
	const cards_4 = [
		{
			products_cod: ["AST20000CCIP0"],
			products_type: ["Ø 2 mm"]
		},
		{
			products_cod: ["AST00000SUIP0"],
			products_type: [""]
		},
		{
			products_cod: ["AST00000CCDN0"],
			products_type: [""]
		},
		{
			products_cod: ["AST00000AMCRC"],
			products_type: [""]
		},
		{
			products_cod: ["AST00000EMCRC"],
			products_type: [""]
		},
		{
			products_cod: ["AST000000PF0"],
			products_type: [""]
		},
		{
			products_cod: ["AST00000G4000"],
			products_type: [""]
		}
	]
	const cards_5 = [
		{
			productCode: ["AUN3508000ST0", "AUN3510000ST0", "AUN3511500ST0", "AUN3513000ST0", "AUN3515000ST0", "AUN5508000ST0", "AUN5510000ST0", "AUN5511500ST0", "AUN5513000ST0", "AUN5515000ST0", "AUN20000FRLL0", "AUN22000DR000", "AUN28000DR000", "AUN32000DR000", "AUN34000DR000", "AUN37000DR000", "AUN41000DR000", "AUN46000DR000", "AUN56000DR000", "AIF33080FRFI0", "AIF33100FRFI0", "AIF33115FRFI0", "AIF33130FRFI0", "AIF33150FRFI0", "AIF37080FRFI0", "AIF37100FRFI0", "AIF37115FRFI0", "AIF37130FRFI0", "AIF37150FRFI0", "AIF42080FRFI0", "AIF42100FRFI0", "AIF42115FRFI0", "AIF42130FRFI0", "AIF42150FRFI0", "AIF50080FRFI0", "AIF50100FRFI0", "AIF50115FRFI0", "AIF50130FRFI0", "AIF50150FRFI0", "AST00000APCRE", "AST12SHOAPCRB", "AST12000APCRB", "AST20000CCIP0", "AST00000SUIP0", "AST00000CCDN0", "AST00000CMCAC", "AST00000APCRC", "AST00300APCRC", "AST00000AMCRC", "AST00000EMCRC", "ATY00CYEIF000"],
			productDescription: lng === "es" ?
				[" Stop Universal Ø 3.5 mm. L.8 mm", " Stop Universal Ø 3.5 mm. L.10 mm.", "Stop Universal Ø 3.5 mm. L.11.5 mm.", "Stop Universal Ø 3.5 mm. L.13 mm.", "Stop Universal Ø 3.5 mm. L.15 mm.", "Stop Universal Ø 5.5 mm. L.8 mm.", " Stop Universal Ø 5.5 mm. L.10 mm.", " Stop Universal Ø 5.5 mm. L.11.5 mm.", " Stop Universal Ø 5.5 mm. L.13 mm.", " Stop Universal Ø 5.5 mm. L.15 mm.", " Fresa Lanceolada Universal Ø 2 mm.", " Fresa Universal Ø 2.2 mm.", " Fresa Universal Ø 2.8 mm.", " Fresa Universal Ø 3.2 mm.", " Fresa Universal Ø 3.4 mm.", " Fresa Universal Ø 3.7 mm.", " Fresa Universal Ø 4.1 mm.", " Fresa Universal Ø 4.6 mm.", " Fresa Universal Ø 5.6 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.15 mm.", " Llave Multi Uso Recta Larga.", " Llave de Fijación Manual para Prótesis - HI-1.20 Corta.", " Llave de Fijación Manual para Prótesis - HI-1.20 Larga.", " Pin de Paralelismo Ø 2 mm. (Cant. 2).", " Indicador de Profundidad.", " Carraca Dinamométrica.", " Llave de Fijación Contra Angulo para Implante - CC-REVCON-Larga.", " Llave de Fijación Manual para Implante - CC-REVCON-Larga.", " Llave de Fijación Manual para Implante - CC-REVCON-Extra Larga.", " Llave de Activación Manual para Pilares - CC-REVCON.", " Llave de Extracción Manual para Pilares - CC-REVCON."," Caja Quirúrgica y Bandeja."] :
				[" Universal Stop Ø 3.5 mm. L.8 mm", " Universal Stop Ø 3.5 mm. L.10 mm.", "Universal Stop Ø 3.5 mm. L.11.5 mm.", "Universal Stop Ø 3.5 mm. L.13 mm.", "Universal Stop Ø 3.5 mm. L.15 mm.", "Universal Stop Ø 5.5 mm. L.8 mm.", " Universal Stop Ø 5.5 mm. L.10 mm.", " Universal Stop Ø 5.5 mm. L.11.5 mm.", " Universal Stop Ø 5.5 mm. L.13 mm.", " Universal Stop Ø 5.5 mm. L.15 mm.", " Universal Lance Drill Ø 2 mm.", " Universal Drill Ø 2.2 mm.", " Universal Drill Ø 2.8 mm.", " Universal Drill Ø 3.2 mm.", " Universal Drill Ø 3.4 mm.", " Universal Drill Ø 3.7 mm.", " Universal Drill Ø 4.1 mm.", " Universal Drill Ø 4.6 mm.", " Universal Drill Ø 5.6 mm.", " Conical Drill IS-FOUR® Ø 3.3 L.08 mm.", " Conical Drill IS-FOUR® Ø 3.3 L.10 mm.", " Conical Drill IS-FOUR® Ø 3.3 L.11.5 mm.", " Conical Drill IS-FOUR® Ø 3.3 L.13 mm.", " Conical Drill IS-FOUR® Ø 3.3 L.15 mm.", " Conical Drill IS-FOUR® Ø 3.75 L.08 mm.", " Conical Drill IS-FOUR® Ø 3.75 L.10 mm.", " Conical Drill IS-FOUR® Ø 3.75 L.11.5 mm.", " Conical Drill IS-FOUR® Ø 3.75 L.13 mm.", " Conical Drill IS-FOUR® Ø 3.75 L.15 mm.", " Conical Drill IS-FOUR® Ø 4.2 L.08 mm.", " Conical Drill IS-FOUR® Ø 4.2 L.10 mm.", " Conical Drill IS-FOUR® Ø 4.2 L.11.5 mm.", " Conical Drill IS-FOUR® Ø 4.2 L.13 mm.", " Conical Drill IS-FOUR® Ø 4.2 L.15 mm.", " Conical Drill IS-FOUR® Ø 5 L.08 mm.", " Conical Drill IS-FOUR® Ø 5 L.10 mm.", " Conical Drill IS-FOUR® Ø 5 L.11.5 mm.", " Conical Drill IS-FOUR® Ø 5 L.13 mm.", " Conical Drill IS-FOUR® Ø 5 L.15 mm."," Straight MUA Key Long."," Manual Fix Key for Prosthetic - IH-1.20 Short."," Manual Fix Key for Prosthetic - IH-1.20 Long."," Parallelism Pin Ø 2 mm. (Qty 2)."," Depth Gauge."," Torque Ratchet."," Contra Angle Fix Key for Implant - CC-REVCON-Long."," Manual Fix Key for Implant - CC-REVCON-Long."," Manual Fix Key for Implant - CC-REVCON-Extra Long."," Manual Activation Key for Abutments - CC-REVCON."," Manual Extraction Key for Abutments - CC-REVCON."," Surgical Box and Tray."]
		}
	]
	const cards_6 = [
		{
			productCode: ["AST12030APCRB", "AST12000APCRB", "AST12SHOAPCRB", "AST1B030APCRB", "AST1B000APCRB", "AST1BSHOAPCRB", "AST12000APCAB", "AST12SHOAPCAB", "AST00000PRCAI", "AST00SHOPRCAI", "AST00000APCRE", "AST00SHOAPCRE", "AST00000AMCRC", "AST00000EMCRC", "AST00SHOAMCRC", "AST00SHOEMCRC", "AST00000CCDN0", "ATY00CYEIF000"],
			productDescription: lng === "es" ?
				[" Llave de Fijación Manual para Prótesis Ø1.20 mm. Extra Larga (L.25 mm.) - CC", " Llave de Fijación Manual para Prótesis Ø1.20 mm. Larga (L.14 mm.) - CC", " Llave de Fijación Manual para Prótesis Ø1.20 mm. Corta (L.8 mm.) - CC", " Llave de Fijación Manual para Prótesis Ø1.25 mm. Extra Larga (L.25 mm.) - HI", " Llave de Fijación Manual para Prótesis Ø1.25 mm. Larga (L.14 mm.) - HI", " Llave de Fijación Manual para Prótesis Ø1.25 mm. Corta (L.8 mm.) - HI", " Llave de Fijación Contra Angulo para Prótesis Ø1.20 mm. Larga (L.14 mm.) - CC", " Llave de Fijación Contra Angulo para Prótesis Ø1.20 mm. Corta (L.9 mm.) - CC", " Llave de Fijación Contra Angulo para Prótesis Ø1.25 mm. Larga (L.14 mm.) - HI", " Llave de Fijación Contra Angulo para Prótesis Ø1.25 mm. Corta (L.9 mm.) - HI", " Llave Multi Uso Recta Larga (L.14 mm.) MUA", " Llave Multi Uso Recta Corta (L.8 mm.) MUA", " Llave de Activación Manual (IN) - Larga - CC", " Llave de Extracción Manual (OUT) - Larga - CC", " Llave de Activación Manual (IN) - Corta - CC", " Llave de Extracción Manual (OUT) - Corta - CC", " Carraca Dinamométrica.", " Caja Quirúrgica y Bandeja."] :
				[" Manual Fix Key for Prosthetic Ø1.20 mm. Extra Long (L.25 mm.) - CC", " Manual Fix Key for Prosthetic Ø1.20 mm. Long (L.14 mm.) - CC", " Manual Fix Key for Prosthetic Ø1.20 mm. Short (L.8 mm.) - CC", " Manual Fix Key for Prosthetic Ø1.25 mm. Extra Long (L.25 mm.) - IH", " Manual Fix Key for Prosthetic Ø1.25 mm. Long (L.14 mm.) - IH", " Manual Fix Key for Prosthetic Ø1.25 mm. Short (L.8 mm.) - IH", " Contra Angle Prosthetic Fixing Key Ø1.20 mm. Long (L.14 mm.) - CC", " Contra Angle Prosthetic Fixing Key Ø1.20 mm. Short (L.9 mm.) - CC", " Contra Angle Prosthetic Fixing Key Ø1.25 mm. Long (L.14 mm.) - IH", " Contra Angle Prosthetic Fixing Key Ø1.25 mm. Short (L.9 mm.) - IH", " Straight MUA Key Long (L.14 mm.)", " Straight MUA Key Short (L.8 mm.)", " Manual Activation Key (IN) - Long - CC", " Manual Extraction Key (OUT) - Long - CC", " Manual Activation Key (IN) - Short - CC", " Manual Extraction Key (OUT) - Short - CC", " Torque Ratchet", " Surgical Box and Tray"]
		}
	]
	const data = {
		cards_1,
		cards_2,
		cards_3,
		cards_4,
		cards_5,
		cards_6
	}
	return data
}
